import {Directive, ElementRef, OnInit, Input, Output, EventEmitter} from '@angular/core';

declare var $: any;

@Directive({
  selector: '[smartClockpicker]'
})
export class SmartClockpickerDirective implements OnInit {

  @Input() smartClockpicker: any;

  @Output()
  change:EventEmitter<string> = new EventEmitter();

  constructor(private el:ElementRef) {
  }

  ngOnInit() {
    System.import('script-loader!clockpicker/dist/bootstrap-clockpicker.min.js').then(()=> {
      this.render()
    })
  }


  render() {
      let options = $.extend(this.smartClockpicker || {placement: 'top',donetext: 'Done'},
          {
          afterDone:()=>{
              this.change.emit(this.smartClockpicker);
          }
        });
    $(this.el.nativeElement).clockpicker(options);
  }

}
